export const css = {
	root: '_2QxRXJsT',
	up: '_2PEQlfkz',
	actions: 'blal3E4V',
	action: 'p6q_PfKg',
	down: '_19lWJ4yW',
	left: '_25I4fFXi',
	right: '_31UL_G-0',
	open: 'YS6kzALP',
	actionTransition: '_3y0rru8g',
	iconOpen: 'sJgADTp4',
	staticTooltip: 'BI6VUXaB',
	closed: 'wEfpJ3Mq',
	action0: '_3wc2hwsP',
	action1: '_1asz-NzP',
	action2: '_2cMWaJUH',
	action3: '_2iyfBRy2',
	action4: '_28lK9enb',
	action5: '_1_BT25ig',
	button: '_187jyCQu',
	pressed: '_1Yr1WOSJ',
	label: '_2LrHcwju',
	large: '_2jlqCaxr',
	small: '_1h3Yb05G',
	' _key': 'base-widgets/speed-dial'
};

export default css;
